import { Component, QueryList, ViewChildren, inject } from '@angular/core';

@Component({
  selector: 'app-spinner',
  //standalone: true,
  //imports: [],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  constructor(){
  }
}

